var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountingPaperNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 19.1665H15C15.9205 19.1665 16.6666 18.383 16.6666 17.4165V3.4165C16.6666 2.45001 15.9205 1.6665 15 1.6665H4.99998C4.0795 1.6665 3.33331 2.45001 3.33331 3.4165V17.4165C3.33331 18.383 4.0795 19.1665 4.99998 19.1665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79492 16.3208H6.988H8.18107",
    stroke: "white",
    strokeWidth: 0.444266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.027 17.4297V15.0435M11.8339 16.3325H14.2201",
    stroke: "white",
    strokeWidth: 0.444266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49003 7.7723C7.49003 8.23254 7.11693 8.60563 6.6567 8.60563C6.19646 8.60563 5.82336 8.23254 5.82336 7.7723C5.82336 7.31206 6.19646 6.93896 6.6567 6.93896C7.11693 6.93896 7.49003 7.31206 7.49003 7.7723ZM7.49003 10.2723C7.49003 10.7325 7.11693 11.1056 6.6567 11.1056C6.19646 11.1056 5.82336 10.7325 5.82336 10.2723C5.82336 9.81206 6.19646 9.43896 6.6567 9.43896C7.11693 9.43896 7.49003 9.81206 7.49003 10.2723ZM6.6767 13.4057C7.13694 13.4057 7.51004 13.0326 7.51004 12.5724C7.51004 12.1122 7.13694 11.7391 6.6767 11.7391C6.21647 11.7391 5.84337 12.1122 5.84337 12.5724C5.84337 13.0326 6.21647 13.4057 6.6767 13.4057ZM10.8234 10.2723C10.8234 10.7325 10.4503 11.1056 9.99007 11.1056C9.52983 11.1056 9.15674 10.7325 9.15674 10.2723C9.15674 9.81206 9.52983 9.43896 9.99007 9.43896C10.4503 9.43896 10.8234 9.81206 10.8234 10.2723ZM10.0101 13.4057C10.4703 13.4057 10.8434 13.0326 10.8434 12.5724C10.8434 12.1122 10.4703 11.7391 10.0101 11.7391C9.54984 11.7391 9.17674 12.1122 9.17674 12.5724C9.17674 13.0326 9.54984 13.4057 10.0101 13.4057ZM14.1567 10.2723C14.1567 10.7325 13.7836 11.1056 13.3234 11.1056C12.8631 11.1056 12.4901 10.7325 12.4901 10.2723C12.4901 9.81206 12.8631 9.43896 13.3234 9.43896C13.7836 9.43896 14.1567 9.81206 14.1567 10.2723ZM13.3434 13.4057C13.8036 13.4057 14.1767 13.0326 14.1767 12.5724C14.1767 12.1122 13.8036 11.7391 13.3434 11.7391C12.8832 11.7391 12.5101 12.1122 12.5101 12.5724C12.5101 13.0326 12.8832 13.4057 13.3434 13.4057ZM10.8234 7.7723C10.8234 8.23254 10.4503 8.60563 9.99007 8.60563C9.52983 8.60563 9.15674 8.23254 9.15674 7.7723C9.15674 7.31206 9.52983 6.93896 9.99007 6.93896C10.4503 6.93896 10.8234 7.31206 10.8234 7.7723ZM13.3234 8.60563C13.7836 8.60563 14.1567 8.23254 14.1567 7.7723C14.1567 7.31206 13.7836 6.93896 13.3234 6.93896C12.8631 6.93896 12.4901 7.31206 12.4901 7.7723C12.4901 8.23254 12.8631 8.60563 13.3234 8.60563Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingPaperNote);
export default __webpack_public_path__ + "static/media/accounting-paper-note.46788c26f2b9f811a2c634f7c2dfddd3.svg";
export { ForwardRef as ReactComponent };